'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var sort = exports.sort = 110;

var styles = exports.styles = function styles(_styles, props) {
	if (props.borderStyle === 'none') {
		return _styles;
	}

	return _extends({}, _styles, {
		'border-style': props.borderStyle,
		'border-width': props.borderWidth,
		'border-color': props.borderColor,
		'border-radius': props.borderRadius
	});
};

var config = exports.config = function config() {
	return {
		label: 'Border',
		props: [{
			name: 'borderStyle',
			inputType: 'select',
			label: 'Border style',
			default: 'none',
			values: ['none', 'dotted', 'dashed', 'solid', 'double']
		}, {
			'name': 'borderWidth',
			'inputType': 'text',
			'label': 'Border width',
			'default': ''
		}, {
			'name': 'borderColor',
			'inputType': 'color',
			'label': 'Border color',
			'default': ''
		}, {
			'name': 'borderRadius',
			'inputType': 'text',
			'label': 'Border radius',
			'default': ''
		}]
	};
};